import { render } from "./FormValidationDoors.vue?vue&type=template&id=b948fe68&scoped=true"
import script from "./FormValidationDoors.vue?vue&type=script&lang=js"
export * from "./FormValidationDoors.vue?vue&type=script&lang=js"

import "./FormValidationDoors.vue?vue&type=style&index=0&id=b948fe68&scoped=true&lang=css"

import exportComponent from "/home/hakii/application-form-proto-admin-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b948fe68"]])

export default __exports__